import { render, staticRenderFns } from "./LinkTypes.vue?vue&type=template&id=021fac38"
import script from "./LinkTypes.vue?vue&type=script&lang=js"
export * from "./LinkTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports